import { IProductsRepository } from "@/repository/warehouse/Products/ProductsRepository.types";
import Api from "@/repository/api";
import { ProductsAddRequestType, ProductsUpdateRequestType } from "@/entity/warehouse/Products/Products";
import qs from "qs";
import {
    DataEntity,
    Products,
} from "@/entity/warehouse/Products/Products.types";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ResponseDataType } from "@/form/form.types";

export class ProductsRepository implements IProductsRepository {
    async fetchAll(data?: FormData): Promise<Products> {
        const response = await Api.get(`/products/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            },
        });
        return response.data as Products;
    }
    async fetchData(data: PaginationRequestType): Promise<DataEntity> {
        const response = await Api.get(`/products/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            },
        });
        return response.data as DataEntity;
    }

    async create(data: ProductsAddRequestType): Promise<ResponseDataType> {
        data.wish_remainder = parseFloat(String(data.wish_remainder));
        data.selling_price = parseFloat(String(data.selling_price));
        data.net_weight = parseFloat(String(data.net_weight));
        data.gross_weight = parseFloat(String(data.gross_weight));
        data.critical_remainder = parseFloat(String(data.critical_remainder));

        const res = await Api.post("/products/create", data);
        return res.data;
    }
    async update(data: ProductsUpdateRequestType): Promise<ResponseDataType> {
        data.wish_remainder = parseFloat(String(data.wish_remainder));
        data.selling_price = parseFloat(String(data.selling_price));
        data.net_weight = parseFloat(String(data.net_weight));
        data.gross_weight = parseFloat(String(data.gross_weight));
        data.critical_remainder = parseFloat(String(data.critical_remainder));

        const res = await Api.post("/products/update", data);
        return res.data;
    }
}
